// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__sTWeG","active":"Navigation_active__woWPH"};